import { render, staticRenderFns } from "./DebitPendingView.vue?vue&type=template&id=2134200c"
import script from "./DebitPendingView.vue?vue&type=script&lang=js"
export * from "./DebitPendingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports